import { IDashboardMetadata } from '../dashboard-metadata.service';
import { OemDashboardFiltersComponent } from '../filters/oem/oem-dashboard-filters.component';
import { DateType } from '../../../../shared/services/date.util';

export const OEM_KPI_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'OEM KPI',
  filterComponent: {
    name: OemDashboardFiltersComponent
  },
  mapping: {
    Decounm: 'country.id',
    Desprnm: 'customer.id',
    Deconti: 'geography.name',
    Pacomnm: 'bp.companyCountryId',
    Devenid: 'oem.id',
    Vnamid: 'vnam.id',
    Amlname: 'arm.id'
  },
  reports: [
    {
      id: 223,
      key: 'PENDING_ITEMS',
      fixedFilters: {
        Customer_kpi_section: 'V',
        Owner_type: '@VNAM@@VREP@@DREP@'
      },
      columns: [
        'Devipnr_ds',
        'Dereqid_ds',
        'Depornr',
        'Pending_date',
        'Age',
        'Dereqst',
        'Owner_type',
        'Owner',
        'Decommt',
        'Decompa',
        'Decounm',
        'Detotal',
        'Actotal',
        'Desubdt',
        'Odlname',
        'Pacomnm',
        'Delamnm',
        'Lacomnm',
        'Delamcn',
        'Decsunm',
        'Decomds',
        'Customer_kpi_section',
        'Kpi_dashboard_name',
        'Gblname',
        'Desk',
        'Deetadt',
        'Doityourself_ds',
        'Oddesk',
        'Vnam',
        'Vrep',
        'Debpref',
        'Dedvref',
        'Deveref',
        'Stocktype',
        'Denamnm'
      ]
    },
    {
      id: 224,
      key: 'NEED_SHIP_DATE',
      comments: 'Orders that have been placed over 21 days ago, but don\'t have a ship date yet<br>' +
        '      To complete this information, you can click on the links to the order one by one, or' +
        '      <ul>' +
        '        <li>Export these items</li>' +
        '        <li>Fill in the blanks</li>' +
        '        <li><a href="/unacc/Index.jsp?URL=ImportOrdDataView_Edit.jsp%3FDeimpty%3DORDDATA%26ejbEvent%3Dcreate%26wv_Demenid%3D924%26wv_Deappid%3D329%26wv_Detitle%3DUpload%2BBP%2Bopen%2Btems" target="_blank">Upload the list</a></li>' +
        '      </ul>',
      fixedFilters: {
        Oemkpitype: 'PLACED_MANUAL_OR_DIRECT'
      }
    },
    {
      id: 220,
      key: 'NEED_OEM_NR',
      comments: ' ',
      fixedFilters: {
        Oemkpitype: 'ORDERS_NO_OEM_PLACED_MANUAL_OR_DIRECT'
      },
      sort: [
        {
          name: 'Dereqid',
          direction: 'asc'
        }
      ],
      columns: [
        'Devipnr_ds',
        'Dereqid',
        'Desubdt',
        'Depladt',
        'Deetadt',
        'Decounm',
        'Debpref',
        'Debdref',
        'Dedvref',
        'Decommt',
        'Pacomnm',
        'Odlname',
        'Detotal',
        'Actotal',
        'Dereqst',
        'Decompa',
        'Delamnm',
        'Lacomnm',
        'Gblname'
      ]
    },
    {
      browselistCode: 'TICKET',
      key: 'OPEN_TICKETS',
      fixedFilters: {
        Deiopen: 1,
        Companytypecreatorandowner: 'V'
      },
      mapping: {
        Shsprnm: 'customer.id',
        Shcounm: 'country.id',
        Deccoid: 'bp.companyCountryId',
        Arm_name: 'arm.id'
      }
    },
    {
      browselistCode: 'TICKET',
      key: 'ARM_TICKETS',
      fixedFilters: {
        Deiopen: 1,
        Demntty: '@NEWBP@@COVERAGE@'
      },
      mapping: {
        Shsprnm: 'customer.id',
        Shcounm: 'country.id',
        Deccoid: 'bp.companyCountryId',
        Arm_name: 'arm.id'
      }
    },
    {
      browselistCode: 'USERS',
      key: 'VNAM_VREP',
      fixedFilters: {
        Decnyid: 'VNAM,VREP',
        Deordby: 'nvl(delogdt, sysdate - 10000) desc'
      },
      mapping: {
        Decomnm: 'oem.id'
      }
    },
    {
      id: 179,
      key: 'OEM_INTEL',
      fixedFilters: {
        Answered: '',
        Dewtyds: 'OEM_CNTRY,COUNTRY',
        Dereadt_FROM: DateType.ONE_WEEK_AGO
      },
      mapping: {
        Desprnm: 'customer.id',
        Deccoid: 'bp.companyCountryId'
      },
      columns: [
        'Dequest', //Question
        'Deanswe', //Answer
        'Deansok_ds', //Answer ok
        'Deansdt', //Answered on
        'Deconnm', //Answered by
        'Decommt', //Comment
        'Decredt', //updated on
        'Decomnm', //Company
        'Desprnm', //Webshop
        'Decounm', //Country
        'Dewtyds', // Type
        'Amlname',
        'Gblname',
        'Dekeywo', //Keyword
        'Odlname', //OD
        'Gvlname' //GBDM OEM
      ]
    },
    {
      id: 195,
      key: 'OEM_BP_COVERAGE',
      fixedFilters: {
        Deprepa_ds: '1,2,3,4,5'
      },
      sort: [
        {
          name: 'Deprepa_ds',
          direction: 'asc'
        }
      ],
      mapping: {
        Decntce: 'country.id',
        Decomnm: 'bp.companyCountryId',
        Vecomnm: 'oem.id'
      },
      columns: [
        'Deprepa_ds', // OEM ranking
        'Decomnm', //BP
        'Txpaycu_ds', // Order Currency
        'Leplato_ds', // Default processing mode
        'Leshpcu_ds', // Default Shipping mode
        'Deordmo', // Order mode
        'Devenva_ds', // Direct Order process
        'Decntce', // Country
        'Vecomnm', // OEM
        'Devbpid', // Sold to Id
        'Deopera_ds', // BP Operational
        'Decodnm', //OD
        'Detiest_ds', // Tier status
        'Dicomnm', // Distributor
        'Dicounm', // Distributor Country
        'Decommt',
        'Deaccnm', //Accrediations
        'Deconti',
        'Vevbpid', //BP ID with OEM
        'Divbpid', //BP ID with Distributor
        'Dehpoid', //Outlet ID
        'Depprid', //PartnerPro ID
        'Deccoid' // BP ID
      ]
    },
    {
      id: 245,
      key: 'OEM_OFT',
      fixedFilters: {
        Tier_status: '0,2'
      },
      sort: [
        {
          name: 'Acsl_ranking',
          direction: 'asc'
        }
      ],
      mapping: {
        Oem: 'oem.id',
        Desprid: 'customer.id'
      }

    },
    {
      id: 43,
      key: 'PASSED_SLA',
      fixedFilters: {
        Declodt_FROM: DateType.ONE_WEEK_AGO,
        Dedate1: null,
        Dedate2: null,
        Destadt: 1,
        Deestim: 0,
        Totsla_diff: '>0',
        Devendo_cart_show: 1,
        Dependi_show: 1
      },
      mapping: {
        Deccoid: 'bp.companyCountryId',
        Devendo: 'oem.id'
      },
      sort: [
        {
          name: 'Totsla_diff',
          direction: 'desc'
        }
      ],
      columns: [
        'Deordnr', //ACSL#
        {
          name: 'Derecdt',
          label: 'Date submitted'
        },
        'Declodt', //Date Closed
        {
          name: 'Totsla_days', //Total expected SLA
          label: 'Expected SLA'
        },
        {
          name: 'Totsla_cycle', //Total real SLA
          label: 'Real SLA'
        },
        {
          name: 'Totsla_diff', //Total Difference SLA
          label: 'Difference'
        },
        'Decloco', //Closed comment
        'Desprnm', //Webshop
        'Decounm', //Country
        'Decomnm', //BP
        'Decodnm', //OD
        'Gblname' //GBDM
      ]
    },
    {
      id: 121,
      key: 'CLF',
      columns: [
        'Decomnm', //Vendor
        'Decounm', //Country
        'Deprdgr', //Product Category
        'Pcclfpc', //Total CLF %
        'Declfix', // CLF Fix
        'Declfst_ds' //CLF Status
      ],
      mapping: {
        Decomnm: 'oem.id'
      }
    },
    {
      id: 120,
      key: 'BP_WITH_PROBLEMS',
      fixedFilters: {
        Debp_ok_ds: '>0'
      },
      mapping: {
        Decntce: 'country.id',
        Devendo: 'oem.id'
      }
    }
  ]
};